<template>
  <div>
    <q-select
      v-model="model"
      use-input
      input-debounce="0"
      label="Assign Association"
      option-label="association_name"
      option-value="id"
      :multiple="multiple"
      :emit-value="true"
      map-options
      :loading="dataLoading"
      :options="options"
      @filter="filterFn"
      @input="$emit('changed', model)"
      v-bind="siteCFG.fields.general"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      id: {
        type: [Number, Array],
        default: null,
      },
      customData: {
        default: null,
      },
      multiple: {
        default: false,
        type: Boolean,
      },
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        siteCFG: "settings/siteCFG",

        data: "associations/list",
        dataLoading: "associations/listLoading",
      }),
    },
    watch: {
      id: function () {
        this.init();
      },
      data: function () {
        this.init();
      },
      customData: function () {
        this.init();
      },
    },
    data: () => ({
      model: null,
      options: [],
    }),
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.options = JSON.parse(
          JSON.stringify(this.customData ? this.customData : this.data)
        );
        this.model = this.id;
      },
      filterFn(val, update) {
        if (val === "") {
          update(() => {
            this.options = JSON.parse(
              JSON.stringify(this.customData ? this.customData : this.data)
            );
          });
          return;
        } else {
          update(() => {
            const needle = val.toLowerCase();
            let options = this.customData ? this.customData : this.data;
            this.options = options.filter(
              (v) => v.association_name.toLowerCase().indexOf(needle) > -1
            );
          });
        }
      },
    },
  };
</script>
